// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"7e97a4d6","901":"33652132"}[chunkId] + ".chunk.css";
};